import { LottieAnimation } from 'components/LottieAnimation/LottieAnimation';
import { LottieAnimationOptions } from 'components/LottieAnimation/LottieAnimationOptions';

import { AnimatedIconContainer } from './AnimatedIcon.styled';
import { AnimatedIconName } from './AnimatedIconName';

type Props = {
  name: AnimatedIconName;
  size: number;
  options?: LottieAnimationOptions;
};

export function AnimatedIcon({ name, size, options }: Props) {
  const data = {
    path: `animations/${name}.json`,
    fallbackPath: `icons/animated/${name}.svg`,
    width: size,
    height: size,
  };

  return (
    <AnimatedIconContainer>
      <LottieAnimation
        data={data}
        size={{ width: size, height: size }}
        options={options}
      />
    </AnimatedIconContainer>
  );
}
